"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _AnimationCirclesModule = _interopRequireDefault(require("../../styles/components/Flushing/AnimationCircles.module.css"));
var _FlushStartPanel = _interopRequireDefault(require("./FlushStartPanel"));
var _Scanning = _interopRequireDefault(require("../../icons/Scanning.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StepOfPreparation = () => {
  const tI = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: _AnimationCirclesModule.default.circle_wrap
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: _AnimationCirclesModule.default.circle
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _Scanning.default,
    className: _AnimationCirclesModule.default.scanning,
    alt: "Loading"
  }), /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "m-0 color-main-color-primary"
  }, "Scanning"), /*#__PURE__*/_react.default.createElement("span", {
    className: "span-little fw-normal",
    style: {
      color: 'var(--main-color-cl-15)'
    }
  }, "Status"))), /*#__PURE__*/_react.default.createElement(_FlushStartPanel.default, {
    enable: false
  })), [tI]);
};
var _default = exports.default = StepOfPreparation;